import MainScript from '../main.js'
//
import DesktopSidebar from './../../DesktopViews/Sidebar.vue'
import DesktopHeader from './../../DesktopViews/Header.vue'
export default {
    name: 'DHome',
    mixins: [MainScript],
    data () {
        return {
           
           
        }
    },
  
    components: {
        'desktop-sidebar': DesktopSidebar,
        'desktop-header': DesktopHeader,
    },
    methods: {},
    created: function(){}
}


// WEBPACK FOOTER //
// ./src/pages/dashboard/desktop/script.js